/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import {DateTime} from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import apiAdmin from '../../services/api-admin';

function InvoicePaymentModal({ show, setModalReconveyanceOrderId, modalReconveyanceOrderId, setShowInvoiceModal, modalReconveyanceOrder, setSubmitted  }) {
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (modalReconveyanceOrder) {
            reset({
                paid: modalReconveyanceOrder.paid || false,
                paidDate: modalReconveyanceOrder.paidDate,
                transactionDetail: modalReconveyanceOrder.transactionDetail || ''
            });
        }
    }, [modalReconveyanceOrder, reset]);
  
    const onSubmitPaymentModal = data => {
       
        const paymentObject = {
            ...data,
            reconveyanceOrderId: modalReconveyanceOrderId,
        }

        const savePaymentInfo = async () => {
            await apiAdmin.post(`/save-reconveyance-payment-details`, paymentObject)
                .then((response) => {
                    if (response.data) {
                        setSubmitted(prev => !prev); 
                        setModalReconveyanceOrderId(null);
                        setShowInvoiceModal(false);
                        reset();
                    } else {
                        setError("There was an error saving the payment details. Please try again.");
                    }
                });
        };

        savePaymentInfo();
    };

    if (!show) return null; 

    return (
        <>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit(onSubmitPaymentModal)}>
                            <div className="modal-header">
                                <h5 className="modal-title">Payment Information for Order #{modalReconveyanceOrderId}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowInvoiceModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-check form-switch mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="paid"
                                        {...register("paid")}
                                    />
                                    <label className="form-check-label" htmlFor="paid">Paid</label>
                                </div>
                                <div className="mb-3">
                                    <Controller
                                        name="paidDate"
                                        control={control}
                                        rules={{
                                            validate: {
                                                dateValid: (value) =>
                                                    !value || DateTime.fromISO(value).isValid || "Invalid date format"
                                            }
                                        }}
                                        render={({ field: { onChange, value } }) => (
                                            <DatePicker
                                                value={value}
                                                onChange={onChange}
                                                className="w-100"
                                                label="Paid Date"
                                            />
                                        )}
                                    />
                                    {errors.paidDate && (
                                        <div className="text-danger">{errors.paidDate.message}</div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="transactionDetail" className="form-label">Transaction Details</label>
                                    <textarea
                                        className="form-control"
                                        id="transactionDetail"
                                        rows="2"
                                        {...register("transactionDetail")}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowInvoiceModal(false)}>Close</button>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default InvoicePaymentModal;

